import { NodeProps } from 'reactflow';

import { InteractionDagNode } from '../../dag/internalDag';
import { DbtDagNode } from '../../dbt-dag';
import { useInternalDagContext } from '../../providers/InternalDagProvider';

export const getAnnotation = <TDbtDagNode extends DbtDagNode>(
  activeDbtCloudProject: string | null,
  data: InteractionDagNode<TDbtDagNode>,
) => {
  const { annotation, dbtCloudProject, resourceType } = data;
  // external nodes don't have an annotation, instead we show the project name
  if (data.isExternalNode) return null;
  const isFromExternalProject =
    !!dbtCloudProject?.trim() &&
    resourceType !== 'project' &&
    dbtCloudProject !== activeDbtCloudProject;
  const deploymentTypePrefix = data.environmentDeploymentType
    ? `[${data.environmentDeploymentType}] `
    : '';
  const annotationText =
    isFromExternalProject && !annotation
      ? `${deploymentTypePrefix}Project: ${dbtCloudProject}`
      : annotation;
  return annotationText;
};

export const Annotation = <TDbtDagNode extends DbtDagNode>({
  data,
}: NodeProps<InteractionDagNode<TDbtDagNode>>) => {
  const { activeDbtCloudProject } = useInternalDagContext();
  const annotationText = getAnnotation(activeDbtCloudProject, data);
  if (!annotationText) return null;
  return (
    <div className="block overflow-hidden text-ellipsis whitespace-nowrap text-sm">
      {annotationText}
    </div>
  );
};
